<template>
    <div class="okraina-retail-selector">
        <div class="item" :class="{ selected: isRetailMode || !isOnlineStoreEnabled }" @click="setMode(true)">Розничный
            магазин</div>

        <div class="item" :class="{ selected: !isRetailMode && isOnlineStoreEnabled }" @click="setMode(false)">
            Интернет-магазин
        </div>

    </div>

    <okraina-sheet v-model:visible="showOnlineDisabledPopup">
        <template v-slot:body>
            <div class="okraina-rsod">
                <b>Дорогие покупатели!</b><br />
                Интернет-магазин Окраина завершил свою работу.<br /><br />

                Наша продукция по-прежнему доступна в фирменных и розничных магазинах, а так же на маркетплейсах и в
                федеральных сетях.

            </div>
        </template>
    </okraina-sheet>
</template>

<script>
import okrainaSheet from "@/components/sheet.vue";

import { mapGetters } from "vuex";

export default {
    name: "okraina-retail-selector",
    components: {
        okrainaSheet
    },
    data() {
        return {
            showOnlineDisabledPopup: false
        }
    },

    computed: {
        ...mapGetters({
            isRetailMode: "retail/isRetailModeOn",
            isOnlineStoreEnabled: "isOnlineStoreEnabled",
        }),
    },


    methods: {

        setMode(value) {

            if (value == false) {
                this.showOnlineDisabledPopup = true;
                return;
            }

            this.$store.dispatch("retail/setRetailModeOn", value);
        }


    },



}

</script>

<style lang="scss">
.okraina-retail-selector {

    border-radius: 24px;
    background: #E8E8E8;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.10) inset;
    padding: 6px;
    margin-bottom: 13px;

    display: grid;
    grid-template-columns: 0.5fr 0.5fr;
    column-gap: 5px;

    .item {
        border-radius: 16px;
        background: var(--color-view-background);
        display: flex;
        height: 36px;
        justify-content: center;
        align-items: center;
        flex: 1 0 0;

        color: var(--color-text-gray);
        text-align: center;
        font-family: Montserrat;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 16px;

        cursor: pointer;

        &.selected {
            background: var(--green-gradient, linear-gradient(90deg, var(--color-color1) 0.06%, #76B82B 98.88%));
            color: var(--color-btn1-text);
        }
    }
}
</style>